module.exports = __webpack_public_path__ + "static/media/WS4@2x.eaa033d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WS/WS4@2x.png
// module id = 753
// module chunks = 0